import { observer } from 'mobx-react';

import { OptionVariationData, PropertyData } from '../../../../../data/model';
import { FabricFacetFiltersTranslation } from '../../../../../localization/SiteTranslation';
import CheckboxElement from '../../../../../shared/components/Checkbox/CheckboxElement';
import { FilterPropertyState } from '../../../../../shared/FilterState/FilterState';
import FacetFilterState from '../../FacetFilterState';
import { filterDescriptionResolver, filterOptionNameResolver } from '../../filterNameResolver';
import css from './FacetFilter.css';

interface FacetFilterProps {
  state: FacetFilterState;
  selectedItems: Array<OptionVariationData>;
  translation: FabricFacetFiltersTranslation;
}

export const FacetFilter = ({ state, selectedItems, translation }: FacetFilterProps) => {
  if (state.availableProperties.length === 0) {
    return null;
  }

  const description = filterDescriptionResolver(state.data, translation);

  return (
    <>
      {description && <div className={css.description}>{description}</div>}
      <div className={css.items}>
        {state.availableProperties.map((item) => (
          <Option state={item} allItems={selectedItems} translation={translation} key={item.data.valueId} />
        ))}
      </div>
    </>
  );
};

export default observer(FacetFilter);

interface OptionProps {
  state: FilterPropertyState;
  allItems: Array<OptionVariationData>;
  translation: FabricFacetFiltersTranslation;
}

const Option = observer(({ allItems, state, translation }: OptionProps) => {
  const availableResultsCount = state.countAvailableResults(allItems);

  return (
    <CheckboxElement
      name={state.data.name}
      value={state.data.value}
      checked={state.selected}
      disabled={availableResultsCount === 0}
      onChange={() => state.toggle()}
    >
      <>
        {`${filterOptionNameResolver(state.data, translation)}`}{' '}
        <span className={css.count}>({availableResultsCount})</span>
      </>
    </CheckboxElement>
  );
});
